<template>
  <v-container  fluid >
    <v-layout row wrap justify-center align-content-start>
        <v-card  width="500px">
          <v-toolbar flat dense class="primary" dark>
            <v-toolbar-title>Change Password</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar> 
          <v-flex layout row wrap align-center justify-center pt-4 pl-4 pr-4>
            <v-flex xs12 pr-2 pl-2>
              <v-text-field
                :value="$store.state.auth.user.email"
                type="text"
                name="userId"
                label="User ID"
                readonly
                box
              ></v-text-field>
            </v-flex>
            <v-flex  xs12 pr-2 pl-2>
              <v-text-field
                v-model="oldPassword"
                type="password"
                name="oldPassword"
                label="Current Password"
                box
              ></v-text-field>
            </v-flex>
            <v-flex  xs12 pr-2 pl-2>
              <v-text-field
                v-model="password"
                type="password"
                name="Password"
                label="New Password"
                box
                @change="$v.password.$touch()"
                :error-messages="passwordErrors"
              ></v-text-field>
            </v-flex>
            <v-flex  xs12 pr-2 pl-2>
              <v-text-field
                v-model="confirmPassword"
                type="password"
                name="confirmPassword"
                label="Confirm Password"
                box
                @change="$v.confirmPassword.$touch()"
                :error-messages="confirmPasswordErrors"
              ></v-text-field>
            </v-flex>
          </v-flex>
          <v-card-actions class="pl-4 pr-4 pb-4">
            <v-flex xs12 layout row wrap>
              <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                <v-btn class="error" block dark flat="flat" @click="cancel()">Cancel</v-btn>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 pl-2 pr-2 pb-2>
                <v-btn class="primary" block dark flat="flat" v-on:click="submit()">Save Changes</v-btn>
              </v-flex>       
            </v-flex>
          </v-card-actions> 
        </v-card>
      <!-- </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, sameAs} from 'vuelidate/lib/validators'
    import UserService from "@/services/UserService";

    export default {
  name: "Settings",
  components: {},
  mixins: [validationMixin],
  data() {
    return {  
      oldPassword: "",
      password: "",
      confirmPassword: "",
    }
  },
  validations: {
      password:{
        required
      },
      confirmPassword: {
        matchText: sameAs('password')
      }
  },
  computed:{
    confirmPasswordErrors () {
      const errors = []
      if (!this.$v.confirmPassword.$invalid) return errors
      !this.$v.confirmPassword.sameAs && errors.push('Passwords do not match')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$invalid) return errors
      !this.$v.password.required && errors.push('Password required')
      return errors
    }
  },
  methods: {
   cancel: function(){      
      // this.$store.dispatch('editTechnician', null)
      // this.$router.push({name: 'allTechnicians'})
      this.$router.go(-1)
    },
    cancelPassword: function(){
      this.edit = false
      this.password = null
      this.oldPassword = null
      this.confirmPassword = null
    },
    // savePassword: function(){
    //   this.$v.$touch()
    //   this.edit = false
    //   this.$store.dispatch('setSnackbar', {show: true, text: "Password changed successfully", color: "success", x:'right', timeout: 3000})
    // },
    async submit() {
      try {
        var color = "info";
        var form = {password : this.password, current_password : this.oldPassword, email : this.$store.state.auth.user.email}
        const response = await UserService.update(form);
        // console.log(response)
        if (response.data.code > 200) {
          color = "warning";
        } else if (response.data.result == 2000) {
          color = "success";
          this.password = null
          this.oldPassword = null
          this.confirmPassword = null
        }

        this.$store.dispatch("setSnackbar", {
          show: true,
          text: response.data.message,
          color: color,
          x: "right",
          timeout: 3000
        });
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setSnackbar", {
          show: true,
          text: "Error occured",
          color: "error",
          x: "right",
          timeout: 3000
        });
      }
    }

  }
};
</script>

<style scoped>

</style>
